import { config } from '@/config.ts';

type BrandFaqConfig = Record<string, string>;

/**
 * Map of FAQ sections for each brand
 * Maps brand to the FAQ data key in get-faq-data.ts
 */
export const brandFaqMap: BrandFaqConfig = {
	default: 'pm',
	nomad: 'pm',
	ngu3: 'ngu3',
	com2: 'com2',
	blitz: 'pm',
	rockets: 'rockets',
	rockets_vip: 'rockets',
	sk2: 'rockets'
};

/**
 * Get FAQ section key for the current brand
 * @returns string - FAQ section key for current brand
 */
export const getBrandFaqSection = (): string => {
	const brand = config.BRAND || 'default';
	return brandFaqMap[brand] || brandFaqMap.default;
};

